import { useEffect, useState } from 'react';
import './../styles/reset-password.css';
import { ClipLoader } from 'react-spinners';
import ToastNotification, { showTopCenterToast } from '../components/toasts/ToastNotification';
import { resetPassword } from '../api/auth.api';

export const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    useEffect(() => {
        document.title = "Đặt lại mật khẩu";

        const storedTheme = localStorage.getItem("theme");
        if (storedTheme === "dark") {
            document.body.classList.add("dark-theme");
        } else {
            document.body.classList.remove("dark-theme");
        }
    }, []);


    const handleResetPassword = async () => {
        if (!token) {
            showTopCenterToast("Thiếu token! Lỗi hệ thống", "error");
            return;
        }

        if (!password || !confirmPassword) {
            showTopCenterToast("Vui lòng nhập đầy đủ thông tin", "error");
            return;
        }

        if (confirmPassword !== password) {
            showTopCenterToast("Xác nhận mật khẩu không đúng", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await resetPassword(token, password);

            if (res.success) {
                showTopCenterToast("Đặt lại mật khẩu thành công, vui lòng đăng nhập!", "success");
                setPassword("");
                setConfirmPassword("")
            }
        } catch (error) {
            showTopCenterToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <div className='forgot-password-container'>
            <ToastNotification/>
            <div className='forgot-password-wrapper'>
                <h3>Cập nhật mật khẩu</h3>
                <p className='forgot-password-text'>Hãy cập nhật lại mật khẩu của bạn và tiếp tục sử dụng dịch vụ nhé.</p>
                <div className='input-button-container'>
                    <input value={password} onChange={(e) => setPassword(e.target.value)} className='forgot-password-email-input' type='password' placeholder='Mật khẩu'></input>
                    <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className='forgot-password-email-input' type='password' placeholder='Xác nhận mật khẩu'></input>
                    <button onClick={handleResetPassword} disabled={loading} className={`send-email-button ${loading && "disabled-button"}`}>{loading ? <ClipLoader size={20} color='#fff'/> : "Cập nhật" }</button>
                </div>
                <a href='/login' className='link-to-login'>Quay lại đăng nhập</a>
            </div>
        </div>
    );
}
